export const menuItems = [
  {
    label: "Dashboard",
    icon: "mdi mdi-apps",
    perm: "view_dashboard",
    link: "/",
  },
  {
    label: "Students",
    icon: "mdi mdi-account-multiple",
    perm: "view_students",
    subItems: [
      {
        label: "New Students",
        perm: "new_student",
        link: "/newstudent",
      },
      {
        label: "View Students",
        perm: "view_student",
        link: "/viewstudents",
      },
      {
        label: "Promote Students",
        perm: "migrate",
        link: "/migrate",
      },
      {
        label: "Parents",
        perm: "view_parents",
        link: "/viewparents",
      },
      {
        label: "Enrollments",
        perm: "view_enrollments",
        link: "/enrollments",
      },
    ],
  },
  {
    label: "Finance",
    icon: "mdi mdi-cash",
    perm: "view_finance",
    subItems: [
      {
        label: "Add Fees Payment",
        perm: "add_fees_payment",
        link: "/newfeespayments",
      },
      {
        label: "View Fees Payments",
        perm: "view_fees_payment",
        link: "/viewfeespayments",
      },
      {
        label: "View Online Payments",
        perm: "view_fees_payment",
        link: "/viewonlinepayments",
      },
      {
        label: "Optional Fees Payments",
        perm: "optional_fees_payments",
        link: "/optionalfeespayments",
      },
      {
        label: "Student Bursaries",
        perm: "student_bursary",
        link: "/studentbursaries",
      },
      {
        label: "Fees Exemptions",
        perm: "student_bursary",
        link: "/feesexemptions",
      },
      // {
      //     label: "Student Optional Fees ",
      //     perm: "student_bursary",
      //     link: "/setoptionalfees",
      // },
      {
        label: "Previous Balances",
        perm: "fees_balances",
        link: "/previousbalances",
      },
    ],
  },
  {
    label: "Primary Assessment",
    icon: "mdi mdi-clipboard-check",
    perm: "view_primary",
    subItems: [
      {
        label: "Add Exam Marks",
        perm: "add_marks_entry",
        link: "/marksentry",
      },
      {
        label: "View Exam Marks",
        perm: "add_marks_entry",
        link: "/viewmarks",
      },
      {
        label: "Report Cards",
        perm: "report_cards",
        link: "/reportcards",
      },
      {
        label: "Report Comments",
        perm: "report_cards",
        link: "/generalcomments",
      },
      // {
      //   label: "Exam Settings",
      //   perm: "exam_sets",
      //   link: "/examsettings",
      // },
      // {
      //   label: "Grading System",
      //   perm: "exam_sets",
      //   link: "/grading",
      // },
    ],
  },
  {
    label: "Nursery Assessment",
    icon: "mdi mdi-clipboard-list",
    perm: "view_nursery",
    subItems: [
      {
        label: "Subject Details",
        perm: "view_nursery",
        link: "/subjectdetails",
      },

      {
        label: "Add Exam Scores",
        perm: "view_nursery",
        link: "/markentry",
      },
      {
        label: "View Exam Scores",
        perm: "view_nursery",
        link: "/viewwmarks",
      },
      {
        label: "Nursery report cards",
        perm: "report_cards",
        link: "/nurseryreports",
      },
      // {
      //     label: "Report Comments",
      //     perm: "grading_system",
      //     link: "/nurseryreportscomments",
      // },
      // {
      //     label: "Grading System",
      //     perm: "grading_system",
      //     link: "/nurserygrading",
      // },
    ],
  },
  {
    label: "Attendance",
    icon: "mdi mdi-clipboard-account-outline",
    perm: "view_attendance",
    subItems: [
      {
        label: "System Attendance",
        perm: "view_student_attendance",
        link: "/systemstudentrollcall",
      },
      {
        label: "Student Roll Call",
        perm: "view_student_attendance",
        link: "/studentrollcall",
      },
      {
        label: "View Student Attendance",
        perm: "view_student_attendance",
        link: "/studentattendance",
      },
      {
        label: "Student Timesheets",
        perm: "view_timesheets",
        link: "/studenttimesheets",
      },
      {
        label: "Staff Attendance",
        perm: "view_staff_attendance",
        link: "/staffattendances",
      },
      {
        label: "Staff Timesheets",
        perm: "view_timesheets",
        link: "/stafftimesheets",
      },
    ],
  },
  {
    label: "SickBay",
    icon: "mdi mdi-bed",
    perm: "view_sickbay",
    subItems: [
      {
        label: "Add a Visit",
        perm: "add_sickbay_visit",
        link: "/addvisits",
      },
      {
        label: "View Visits",
        perm: "view_sickbay_visit",
        link: "/viewvisits",
      },
    ],
  },
  {
    label: "Library",
    perm: "visit_library",
    icon: "mdi mdi-library",
    subItems: [
      {
        label: "Books Borrowed",
        perm: "books_borrowed",
        link: "/booksborrowed",
      },
      {
        label: "Book Categories",
        perm: "book_categories",
        link: "/bookcategories",
      },
      {
        label: "Library Books",
        perm: "library_books",
        link: "/librarybooks",
      },
      {
        label: "Book Store",
        perm: "book_store",
        link: "/bookstore",
      },
    ],
  },
  {
    label: "Human Resource",
    icon: "mdi mdi-account-settings",
    perm: "view_hrr",
    subItems: [
      {
        label: "Staff Members",
        perm: "add_staff",
        link: "/staffmembers",
      },
      {
        label: "Positions",
        perm: "add_roles",
        link: "/positions",
      },
      {
        label: "Departments",
        perm: "add_roles",
        link: "/schooldepartments",
      },
      {
        label: "Salary Details",
        perm: "view_salary_details",
        link: "/salarydetails",
      },
      {
        label: "Allowances",
        perm: "view_allowances",
        link: "/allowances",
      },
      {
        label: "Advances",
        perm: "view_allowances",
        link: "/staffadvances",
      },
      {
        label: "Staff Leaves",
        perm: "view_staff_leaves",
        link: "/staffleaves",
      },
      {
        label: "Deductions",
        perm: "view_allowances",
        link: "/deductions",
      },
    ],
  },
  {
    label: "Pocket Money",
    icon: "mdi mdi-cash",
    perm: "view_finance",
    subItems: [
      {
        label: "Pocket Money",
        perm: "view_pm",
        link: "/pocketmoney",
      },
      {
        label: "Savings",
        perm: "view_pm",
        link: "/savings",
      },
      {
        label: " Withdraws",
        perm: "view_pm",
        link: "/withdraws",
      },
      {
        label: "Balances",
        perm: "view_pm",
        link: "/balances",
      },
    ],
  },
  {
    label: "Student's Cafe",
    icon: "mdi mdi-cart-outline",
    perm: "view_canteen",
    subItems: [
      {
        label: "Canteens",
        perm: "add_canteen",
        link: "/canteens",
      },
      {
        label: "Attendants",
        perm: "add_canteen_users",
        link: "/canteenusers",
      },
      {
        label: "Products",
        perm: "view_products",
        link: "/products",
      },

      {
        label: "Point of Sale",
        perm: "view_salespoint",
        link: "salespoint",
      },
      {
        label: "Sales Invoice",
        perm: "view_salesinvoice",
        link: "/salesinvoice",
      },
    ],
  },
  {
    label: "Expenses",
    icon: "mdi mdi-database",
    perm: "view_expenses",
    subItems: [
      {
        label: "Record Expense",
        perm: "record_expenses",
        link: "/recordexpense",
      },
      {
        label: "View Expenses",
        perm: "edit_expenses",
        link: "/viewexpenses",
      },
      {
        label: "Expense Items",
        perm: "expense_items",
        link: "/expenseitems",
      },
      {
        label: "Expense Categories",
        perm: "expense_categories",
        link: "/expensecategories",
      },
    ],
  },
  {
    label: "Inventory",
    icon: "mdi mdi-book",
    perm: "view_inventory",
    subItems: [
      {
        label: "Units",
        perm: "view_inventory",
        link: "/inventoryunits",
      },
      {
        label: "Items",
        perm: "view_inventory",
        link: "/inventoryitems",
      },
      {
        label: "Store",
        subItems: [
          {
            label: "Add",
            perm: "view_inventory",
            link: "/add-to-store",
          },
          {
            label: "Losses",
            perm: "view_inventory",
            link: "/store-loses",
          },
          {
            label: "View",
            perm: "view_inventory",
            link: "/view-store",
          },
        ],
      },
      {
        label: "Requisition",
        subItems: [
          {
            label: "Add",
            perm: "view_inventory",
            link: "/add-order",
          },

          {
            label: "View",
            perm: "view_inventory",
            link: "/view-order",
          },
        ],
      },
    ],
  },
  {
    label: "School Requirement",
    icon: "mdi mdi-clipboard-outline",
    perm: "requirements",
    subItems: [
      {
        label: "Item",
        perm: "requirements",
        link: "/school-requirement",
      },
      {
        label: "Allocation",
        perm: "requirements",
        link: "/requirement-allocation",
      },
      {
        label: "Collection",
        perm: "requirements",
        link: "/requirement-collection",
      },
      {
        label: "View  Collection",
        perm: "requirements",
        link: "/view-requirement-collection",
      },
    ],
  },
];
